import Vue from 'vue';
if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}
import AnalyzePoint from '../../resource/plugins/AnalyzePoint/index';
Vue.use(AnalyzePoint('global-login', 'login', true));

import { initBiPoint } from '../../resource/plugins/biPoint/index';
import App from '../../App.vue';
import router from '../rooters/webLogin';
import store from '../stores/webLogin';

import setCommonPlugins from '../../resource/configs/setGlobalCommonPlugins';
import clickThrottling from '../../resource/plugins/clickThrottling';

import globalConfig from '../../resource/utiles/globalConfig';
import '@plugins/replaceAllPolyfills';
globalConfig.setPageTitleAndIco('passport');
setCommonPlugins(Vue);

initBiPoint({ dataLayerName: 'passportDataLayer' });

// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(800);
Vue.config.productionTip = true;

globalConfig.setVuePrototypePlatformConfig(Vue);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#webLogin');
